// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"_3IhJ5","loader":"_21Xvv"};